import { useCallback } from 'react'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { InputHidden } from '../../../../../../../../forms/Input'
import TwinForm from '../../../../../../../../forms/TwinForm'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { twinFetchPostPrinter } from '../../../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

type ModalPrintCashRegisterProps = ModalEditComponentProps & {}

const ModalPrintCashRegister: React.FC<ModalPrintCashRegisterProps> = ({ setOpened, allRowData }) => {
    const { loading, onPreSubmit, onSubmit } = useModalPrintCashRegisterLogic({ setOpened })
    const { t } = useTwinTranslation()
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} onClickOut={false} className='flex_height'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action={'/api/app/order/tpv/cashRegister/printCashRegister'} onSubmit={onSubmit} className='flex flex-auto flex-col justify-between gap-20 ' triggerErrors={false} triggerSuccess={false}>
                <h2><TwinTrans transKey='printCashRegister'>Imprimir registro de caja</TwinTrans></h2>
                <span><TwinTrans transKey='pressButtonForPrintReceipt'>Pulsa el botón para imprimir el recibo</TwinTrans></span>
                <InputHidden name='id' value={allRowData?.id} />
                <ButtonsModalSmallCentered confirmText={t('print', 'Imprimir')} setOpened={() => { }} onCancel={() => setOpened(null)} loading={loading} />
            </TwinForm>
        </ModalSmallCentered>
    )
}

interface ModalPrintCashRegisterLogicProps {
    setOpened: ModalOpenedSetTy
}

const useModalPrintCashRegisterLogic = ({ setOpened }: ModalPrintCashRegisterLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const { t } = useTwinTranslation()
    const errorMessage = t('couldNotConnectWithPrinter', 'No se ha podido conectar con la impresora')
    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        startLoading()
        return true
    }, [startLoading])

    const onSubmit: OnSubmit = useCallback(async (result) => {
        if (result && result.status === 367) {
            const body = await result.json()
            const myresult = await twinFetchPostPrinter('/print', body, errorMessage)
            if (myresult) {
                setOpened(null)
            }
        }
        endLoading()
    }, [endLoading, setOpened, errorMessage])
    return { onPreSubmit, onSubmit, loading, endLoading }
}

export default ModalPrintCashRegister